import React from "react";
import CustomDropdown from "../../../components/commons/CustomDropDown";
import Filters from "../../immobilier/componnents/Filter";
import AddPromoteur from "./AddPromoteur";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../redux/actions/modalActions";

const PromoteursHeader = ({
  searchfilter,
  setSearchfilter,
  handleItemSearch,
}) => {
  const applyFilters = (filters) => {
    console.log("Applied Filters:", filters);
  };

  const resetFilters = () => {
    console.log("Filters reset");
  };
  const { user } = useSelector((state) => state.userAuthReducer);
  const dropdownOptions = [
    { value: "tout", label: "Tout" },
    { value: "nbrProgrammes", label: "Nbr de Programmes" },
    { value: "nbrLots", label: "Nbr de lots" },
  ];

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { value } = e.target;
    setSearchfilter(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleItemSearch();
    }
  };

  const handleAddPromoteurModal = () => {
    dispatch(
      openModal({
        title: "Ajouter un Promoteur",
        content: <AddPromoteur />,
      })
    );
  };

  return (
    <div className="d-flex bg-white headerRadius5 headerContainer align-items-center justify-content-between">
      <div className="d-flex align-items-center gap10">
        <div className="d-flex align-items-center gap10 bg-white radius5 px-20 py-2px searchBar">
          <img src="./icons/search.svg" alt="search" height={16} width={16} />
          <input
            type="search"
            onChange={handleInputChange}
            onKeyDown={handleKeyPress}
            value={searchfilter}
            placeholder="Rechercher"
            className="inputSearch border-0"
          />
        </div>
        <button
          className="border-0 bg-pink px-20 py-10 radius5 hoverOpacity"
          onClick={handleItemSearch}
        >
          <img
            src="./icons/search_white.svg"
            alt="search"
            height={16}
            width={16}
          />
        </button>
      </div>
      {/* <div className="d-flex gap10 align-items-center dropdownMenu">
        <p>Trier par</p>
        <CustomDropdown options={dropdownOptions} />
      </div> */}
      <div className="filter d-flex align-items-center gap40">
        {(user.role.name === "Administrateur" ||
          (user.role.name === "Collaborateur" && user.createPromoter)) && (
          <button
            className="d-flex align-items-center gap10 radius5 px-20 py-10 border-0 t02 bg-pink text-white hoverOpacity"
            onClick={handleAddPromoteurModal}
          >
            <img src="./icons/add_promoteur.svg" alt="" />
            <p className="d-none d-xxl-flex">Créer un promoteur</p>
          </button>
        )}
        {/*   <div className="d-flex align-items-center gap10">
          <p>Filtrer</p>
          <Filters
            onApplyFilters={applyFilters}
            onResetFilters={resetFilters}
          />
        </div> */}
      </div>
    </div>
  );
};

export default PromoteursHeader;
